// extracted by mini-css-extract-plugin
export default {"modal":"haa","heading":"iaa","product":"jaa","note":"kaa","notetitle":"laa","notetext":"maa","line":"naa","plan":"oaa","planimage":"paa","description":"qaa"};
    if(module.hot) {
      // 1713809680256
      var cssReload = require("../../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  